<!-- rota: /entegrasyon/index  (name: entegrasyon-index) -->
<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{ $t('Download-Integration-File') }} </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-flex>

          <v-container fluid="">
            <v-card color="grey lighten-5" flat>
              <v-layout row wrap>
                <v-flex xs12 sm4 md2>
                  <v-menu
                    :close-on-content-click="true"
                    v-model="menu"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      :label="$t('Starting-Date')"
                      v-model="dateFormatted"
                      append-icon="event"
                      v-on:change="onChange"
                      mask="##.##.####"
                      @blur="date = parseDate(dateFormatted)"
                      data-vv-name="tarihsec"
                      :error-messages="errors.collect('tarihsec')"
                      v-validate="'required'"
                      required
                    ></v-text-field>
                    <v-date-picker
                      locale="tr"
                      v-model="date"
                      @input="dateFormatted = formatDate($event)"
                      no-title
                      scrollable
                      actions
                    >
                      <v-spacer></v-spacer>
                    </v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm4 md2>
                  <v-menu
                    :close-on-content-click="true"
                    v-model="menu2"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      :label="$t('Finishing-Date')"
                      v-model="dateFormatted2"
                      append-icon="event"
                      v-on:change="onChange2"
                      mask="##.##.####"
                      @blur="date2 = parseDate2(dateFormatted2)"
                      data-vv-name="tarihsec1"
                      :error-messages="errors.collect('tarihsec1')"
                      v-validate="'required'"
                      required
                    ></v-text-field>
                    <v-date-picker
                      locale="tr"
                      v-model="date2"
                      @input="dateFormatted2 = formatDate2($event)"
                      no-title
                      scrollable
                      actions
                    >
                      <v-spacer></v-spacer>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm4 md2>
                  <v-layout align-center justify-center row fill-height>
                    <v-select
                      :items="tipitems"
                      :label="$t('Process-Type')"
                      v-model="tip"
                    ></v-select>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm1 md1>
                  <v-layout>
                    <!-- getList() Promise donduruyor, dolayisiyla buton
                         istek bitene kadar VE sonrasinda 2 saniye boyunca
                         pasif kaliyor; ayrica cift tik engelleniyor.
                         v-if KULLANILMIYOR: buton DOM'dan kalkinca bilesen
                         yok edilir, geri geldiginde sifirdan yaratilir ve
                         bekleme sayaci kaybolurdu (tarayicida olculdu). -->
                    <kaydetbutonu
                      :action="getList"
                      color="info"
                      :flat="false"
                      fab
                      small
                      dark
                    >
                      <v-icon>save_alt</v-icon>
                    </kaydetbutonu>
                    <!-- Buton yalnizca filtresi sunucuya GERCEKTEN giden
                         tiplerde gorunur. Kalan tiplerde gorunuyordu ama secim
                         istege hic konmadigi icin sessizce yok sayiliyordu.
                         Bkz. filtreEtkiliMi. -->
                    <v-btn
                      v-if="filtreEtkiliMi"
                      color="info"
                      @click.native="dialog = true"
                      fab
                      small=""
                      dark
                    >
                      <v-icon>filter_list</v-icon>
                    </v-btn>
                    <!-- Muhasebe kodlari hem satis hem ALIS aktariminda
                         gerekli; ekranda ikisi ayri sekmede. -->
                    <v-btn
                      v-if="logoKodlariGerekli"
                      color="warning"
                      @click.native="LogoKodlariAc()"
                      fab
                      small=""
                      dark
                      title="Logo muhasebe kodlari"
                    >
                      <v-icon>settings</v-icon>
                    </v-btn>
                    <!--
                      Secerek aktarim (dis muhasebe) sayfasina kisayol.
                      YALNIZCA Logo Fatura(Test) ve Logo Alis Faturasi(Test)
                      secilince gorunur: bu ekran araligin tamamini tek
                      seferde aktarirken secerek aktarim ekrani
                      kullaniciya tek tek belge secme imkani veriyor.
                      Karsiligi olan yalnizca bu iki tip (satis = Fatura,
                      alis = Maliyet), o yuzden diger tiplerde
                      gosterilmiyor. Alista sayfa Maliyet tipiyle acilir
                      (bkz. disMuhasebeAktarimAdresi).

                      Fab DEGIL: "Test" ibaresi gorunur metin olarak
                      kalsin diye - fab'daki gibi yalnizca ikon olsaydi
                      etiket bir tooltip'e gomulur, dokunmatik ekranda
                      hic gorunmezdi. EN SAGDA duruyor: kumedeki digerleri
                      (kaydet/filtre/ayarlar) hep vardi, bu en yeni
                      ve en az kullanilan - soldaki alismis butonlarin
                      yerini degistirmesin diye sona kondu.
                    -->
                    <v-btn
                      v-if="disMuhasebeKisayoluVar"
                      color="purple"
                      outline
                      small
                      @click.native="DisMuhasebeAktarimiAc"
                    >
                      <v-icon left small>list_alt</v-icon>
                      Dış Muhasebe Aktarımı (Test)
                    </v-btn>
                  </v-layout>
                </v-flex>
       
              </v-layout>
            </v-card>

            <v-layout row justify-center>
              <v-dialog
                v-model="dialog"
                persistent
                :max-width="logoFiltresiMi || logoAlisFiltresiMi ? 420 : 290"
              >
                <v-card>
                  <v-card-title class="headline">{{ $t('Filter-selection') }}</v-card-title>
                  <!-- Filtreler islem tipine gore degisir: Logo aktarimi
                       geciciStatus'u tanimaz, kendi ucu filtresi vardir. -->
                  <v-card-text v-if="logoFiltresiMi">
                    <v-select
                      :items="logoHatSecenekleri"
                      :label="$t('Line-Type')"
                      v-model="logoFiltreHat"
                    ></v-select>
                    <v-text-field
                      :label="$t('Airline-Code')"
                      v-model="logoFiltreHavayolu"
                      clearable
                    ></v-text-field>
                    <v-text-field
                      :label="$t('Customer-Code')"
                      v-model="logoFiltreMusteri"
                      clearable
                    ></v-text-field>
                    <v-text-field
                      :label="$t('Invoice-Serial')"
                      v-model="logoFiltreFaturaSeri"
                      clearable
                    ></v-text-field>
                    <!-- Bilet.FaturaNo sayisal bir kolon; sunucu sayisal
                         olmayan degeri 400 ile reddediyor. Maske istegin hic
                         gonderilmemesini sagliyor.
                         9 hane: Delphi ayni alani ciktida 7 karaktere
                         sabitliyor (LogoFatEntUnit.pas, BSetlength(...,7)),
                         yani gercek numaralar bu sinirin altinda kaliyor ve
                         maske sessizce kirpma yapmaz. Seri alani maskesiz;
                         harf icerebiliyor. -->
                    <v-text-field
                      :label="$t('Invoice-No')"
                      v-model="logoFiltreFaturaNo"
                      mask="#########"
                      clearable
                    ></v-text-field>
                  </v-card-text>
                  <v-card-text v-else-if="logoAlisFiltresiMi">
                    <v-select
                      :items="logoHatSecenekleri"
                      :label="$t('Line-Type')"
                      v-model="logoFiltreHat"
                    ></v-select>
                    <v-text-field
                      :label="$t('Airline-Code')"
                      v-model="logoFiltreHavayolu"
                      clearable
                    ></v-text-field>
                    <!-- BSP biletlerinin maliyeti BSP mutabakatindan gelir;
                         ayrica alis faturasi uretilmemelidir. -->
                    <v-checkbox
                      label="BSP biletlerini haric tut"
                      v-model="logoAlisBspHaric"
                      hide-details
                    ></v-checkbox>
                    <!-- Acikken CURR_INVOICE / TC_XRATE / TC_NET yazilmaz;
                         Logo belgeyi TL sayar. -->
                    <v-checkbox
                      label="Faturalari TL aktar"
                      v-model="logoAlisTlAktar"
                      hide-details
                    ></v-checkbox>
                  </v-card-text>
                  <v-card-text v-else
                    ><v-checkbox
                      :label="$t('Add-Temporary-Current-Tickets')"
                      v-model="geciciStatus"
                    ></v-checkbox
                  ></v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.native="dialog = false"
                      >{{ $t('Cancel') }}</v-btn
                    >
                    <v-btn color="primary" flat @click="filtrele()"
                      >{{ $t('save_button') }}</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- Logo muhasebe kod eslesmeleri. Tablo bos oldugunda aktarim
                   hicbir satira kod atayamiyor; kullanici kodlari buradan
                   girer, seed script'i beklemeye gerek kalmaz. -->
              <v-dialog v-model="logoKodDialog" max-width="1100" persistent>
                <v-card>
                  <v-card-title class="headline">
                    Logo muhasebe kodlari
                  </v-card-title>
                  <v-card-text>
                    <!-- Satis ve alis kodlari ayni tabloda durur (ayirici
                         IsPurchase), iade kodlari ayri tabloda
                         (IntegrationRefundAccountCode); sunucu hepsini TEK
                         listede, her satirda BelgeTuru ile gonderir. Ekranda
                         yalnizca secili kume gosterilir; kaydetme TUM
                         listeyi gonderdigi icin gorunmeyen kumedeki
                         duzenlemeler korunur. -->
                    <v-btn-toggle v-model="logoTur" mandatory class="mb-2 mr-3">
                      <v-btn flat value="S">Satis</v-btn>
                      <v-btn flat value="A">Alis</v-btn>
                      <v-btn flat value="SI">Satis Iadesi</v-btn>
                      <v-btn flat value="AI">Alis Iadesi</v-btn>
                    </v-btn-toggle>

                    <v-btn-toggle v-model="logoHat" mandatory class="mb-2">
                      <v-btn flat value="I">Ic hat</v-btn>
                      <v-btn flat value="D">Dis hat</v-btn>
                    </v-btn-toggle>

                    <div class="mb-2 grey--text">
                      <template v-if="logoAlisMi">
                        Alis satirlarinda tutar havayoluna olan borctur;
                        <b>Gider hesabi</b> alanina yazilan kod Logo'da
                        MASTER_CODE olur. Ic hat alislarinda bilet ve vergi
                        satirlarinin KDV'si ayri yazilir; bu satirlarda
                        <b>KDV hesabi</b> Logo'da GL_CODE2 olur. Dis hat
                        alisinda KDV yoktur. Alan vergisi ayri bir kalem
                        tipidir. Istisna kodu alista kullanilmadigi icin
                        gosterilmez.
                      </template>
                      <template v-else-if="logoIadeMi">
                        {{ logoTur === 'AI' ? 'Alis iadesi' : 'Satis iadesi' }}
                        satirlarinda <b>{{ logoHesapEtiketi }}</b> Logo'da
                        GL_CODE1 olur. <b>Kart kodu (MASTER_CODE)</b> bos
                        birakilirsa yerine
                        {{ logoTur === 'AI' ? 'gider' : 'gelir' }} hesabi
                        yazilir. <b>KDV hesabi</b> yalnizca ic hatta %18 / %20
                        KDV'li satirlarda kullanilir. {{ logoHesapEtiketi }}
                        bos birakilan satir silinir.
                      </template>
                      <template v-else>
                        Gelir kodu bos birakilan satir silinir, yani o kalem
                        tanimsiz kalir.
                      </template>
                      <br />
                      Kaydet sekiz kumedeki (satis / alis / satis iadesi /
                      alis iadesi x ic/dis) degisikliklerin TAMAMINI birlikte
                      gonderir; kume degistirmek yaptiginiz duzenlemeyi
                      kaybettirmez.
                    </div>
                    <v-progress-linear
                      v-if="logoKodYukleniyor"
                      indeterminate
                    ></v-progress-linear>
                    <v-data-table
                      :headers="logoKodBasliklari"
                      :items="logoKodlarFiltreli"
                      hide-actions
                      class="elevation-1"
                    >
                      <template slot="items" slot-scope="props">
                        <!-- maxlength kolon boylari: gelir / kart / KDV
                             kodu nvarchar(30), istisna kodu nvarchar(10)
                             (IntegrationAccountCode,
                             IntegrationRefundAccountCode). Sunucu asan
                             degeri HIC yazmadan 400 ile reddediyor (mesaj
                             HataYonetimi -> HataMesajiCoz ile gorunur);
                             kutu sinirlamasaydi tek bir uzun kod butun
                             listenin kaydini durdururdu. Secerek aktarim
                             sayfasindaki izgarayla ayni sinirlar. -->
                        <td>{{ LogoSatirTipiAdi(props.item.SatirTipi) }}</td>
                        <td v-if="logoSatisMi">
                          {{ props.item.KdvliMi ? 'KDV li' : 'KDV siz' }}
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.GelirKodu"
                            maxlength="30"
                            hide-details
                            class="mt-0 pt-0"
                            single-line
                          ></v-text-field>
                        </td>
                        <!-- Kart kodu (MASTER_CODE) yalnizca iade kumelerinde. -->
                        <td v-if="logoIadeMi">
                          <v-text-field
                            v-model="props.item.MasterKodu"
                            maxlength="30"
                            hide-details
                            class="mt-0 pt-0"
                            single-line
                          ></v-text-field>
                        </td>
                        <!-- KDV hesabi alista ve iadede de var (ic hat
                             KDV'si); KDV durumu ve istisna yalnizca satista.
                             Hucreler basliklarla AYNI kosulda - bkz.
                             logoKodBasliklari. -->
                        <td>
                          <v-text-field
                            v-model="props.item.KdvKodu"
                            maxlength="30"
                            hide-details
                            class="mt-0 pt-0"
                            single-line
                          ></v-text-field>
                        </td>
                        <td v-if="logoSatisMi">
                          <v-text-field
                            v-model="props.item.MuafiyetKodu"
                            maxlength="10"
                            hide-details
                            class="mt-0 pt-0"
                            single-line
                          ></v-text-field>
                        </td>
                      </template>
                    </v-data-table>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.native="logoKodDialog = false">
                      {{ $t('Cancel') }}
                    </v-btn>
                    <kaydetbutonu
                      :action="LogoKodlariKaydet"
                      :disabled="logoKodYukleniyor"
                    />
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>

            <v-layout row="" wrap>
              <v-flex xs12 sm12 md12>
                <span v-if="!load1">
                  {{ $t('Your-file-is-being-downloaded-Please-wait') }}</span
                >

                <v-snackbar
                  :timeout="timeout"
                  :top="y === 'top'"
                  :bottom="y === 'bottom'"
                  :right="x === 'right'"
                  :left="x === 'left'"
                  :multi-line="mode === 'multi-line'"
                  :vertical="mode === 'vertical'"
                  v-model="snackbar"
                >
                  {{ text1 }}
                  <v-btn flat color="pink" @click.native="snackbar = false">{{
                    $t("Close")
                  }}</v-btn>
                </v-snackbar>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import auth from "../../../api/auth";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "@/components/app/coper/tools.js";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import kaydetbutonu from "@/components/app/customcomp/kaydetbutonu.vue";
import muhasebekodturu from "@/components/app/entegrasyon/muhasebekodturu.js";

export default {
  data() {
    return {
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      tip: "0",

      // Logo muhasebe kod eslesmesi dialogu
      logoKodDialog: false,
      logoKodYukleniyor: false,
      logoHat: "I",

      // "S" satis, "A" alis, "SI" satis iadesi, "AI" alis iadesi. Sunucudaki
      // BelgeTuru'nun (0-3) ekran karsiligi; bkz. muhasebekodturu.js.
      logoTur: "S",
      logoKodlar: [],
      tipitems: [
        {
          text: this.$t('Ticket'),
          value: "0",
        },
        {
          text: this.$t("Bill"),
          value: "1",
        },
        {
          text: this.$t("Refund"),
          value: "2",
        },
        {
          text: "Cari Hareket",
          value: "3",
        },
        {
          text: this.$t('Free-Invoice'),
          value: "4",
        },
        {
          text: "Coper Fatura(Test)",
          value: "5",
        },
        {
          text: "Logo Fatura(Test)",
          value: "6",
        },
        {
          text: "Logo Alis Faturasi(Test)",
          value: "7",
        },
      ],

      dictionary: {
        custom: {
          tarihsec: {
            required: () => this.$t('Please-select-a-date'),
          },
          tarihsec1: {
            required: () => this.$t('Please-select-a-date'),
          },
        },
      },

      date: null,
      menu: false,
      dateFormatted: "",
      date2: null,
      menu2: false,
      dateFormatted2: "",
      load1: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      geciciStatus: false,
      dialog: false,

      // Logo aktariminin filtreleri. Sunucu bunlari bastan beri kabul
      // ediyordu ama istekte sabit gonderiliyorlardi.
      logoFiltreHat: 2, // 0 ic hat, 1 dis hat, 2 hepsi
      logoFiltreHavayolu: "",
      logoFiltreMusteri: "",
      logoFiltreFaturaSeri: "",
      logoFiltreFaturaNo: "",

      // Alis aktariminin kendi filtreleri. Satisla ORTAK olan yalnizca hat
      // ve havayolu; fatura seri/no alis tarafinda anlamsizdir cunku alis
      // faturasi biletten turer.
      logoAlisBspHaric: false,
      // Varsayilan ACIK: Tekser'de ALOGO_TL_AKTAR = E ve Delphi kutuyu her
      // acilista isaretli yukler. Kapali acilinca USD / EUR biletler doviz
      // alanlariyla (CURR_INVOICE / TC_*) gidiyordu.
      logoAlisTlAktar: true,

      // beforeRouteEnter icinde atanir. data()'da tanimlanmasi sart:
      // aksi halde reaktif olmayan bir alan olusuyordu ve deger, geri
      // cagrisi mounted()'dan SONRA kostugu icin bir sure tanimsiz kaliyordu.
      prevRoute: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,
  components: {
    yetkidialog,
    hatadialog,
    kaydetbutonu,
  },
  mounted() {
    this.$validator.localize("en", this.dictionary);
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    if (this.sayfayetki.Status != true) {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          }
        });
    }
  },
  computed: {
    /**
     * Filtre butonunun gorunecegi islem tipleri. Her tip AYNI filtreyi
     * kullanmiyor:
     *   Bilet (0), Fatura (1) -> geciciStatus
     *   Logo  (6)             -> Hat / HavayoluKodu / MusteriKodu
     * Kalan tiplerin istek nesnelerinde hicbir filtre alani yok; buton orada
     * gorunse secim sessizce yok sayilirdi.
     */
    filtreEtkiliMi() {
      return (
        this.tip === "0" ||
        this.tip === "1" ||
        this.logoFiltresiMi ||
        this.logoAlisFiltresiMi
      );
    },

    /** Filtre dialogu Logo SATIS alanlarini gosterecek mi. */
    logoFiltresiMi() {
      return this.tip === "6";
    },

    /** Filtre dialogu Logo ALIS alanlarini gosterecek mi. */
    logoAlisFiltresiMi() {
      return this.tip === "7";
    },

    /** Muhasebe kodu ekrani hangi tiplerde acilabilir. */
    logoKodlariGerekli() {
      return this.logoFiltresiMi || this.logoAlisFiltresiMi;
    },

    /**
     * Secerek aktarim sayfasina kisayol hangi tiplerde gorunur: Logo satis
     * (sayfada Fatura) ve Logo alis (sayfada Maliyet). logoKodlariGerekli
     * ile bugun ayni kume ama anlami farkli; biri degisince digeri
     * pesinden surulmesin diye ayri.
     *
     * Iade (sayfada ?tip=I / ?tip=AI) icin kisayol YOK: bu ekranda Logo
     * iade tipi yok. "Refund" (2) Delphi programinin GIRDI dosyasini
     * (iade_entegrasyon.xml) indiriyor, Logo'ya aktarim degil; oradan
     * secerek Logo aktarimina gecmek iki ayri akisi karistirirdi.
     */
    disMuhasebeKisayoluVar() {
      return this.logoFiltresiMi || this.logoAlisFiltresiMi;
    },

    /**
     * Kisayolun adresi. Alista sayfa ?tip=M ile acilir ve Maliyet secili
     * gelir; satista adres ONCEKI haliyle ayni (sayfanin varsayilani Fatura).
     */
    disMuhasebeAktarimAdresi() {
      return this.logoAlisFiltresiMi
        ? "#/entegrasyon/dismuhasebeaktarim?tip=M"
        : "#/entegrasyon/dismuhasebeaktarim";
    },

    /** Sunucudaki Hat filtresi: 0 ic hat, 1 dis hat, 2 hepsi. */
    logoHatSecenekleri() {
      return [
        { text: this.$t("All"), value: 2 },
        { text: this.$t("Domestic-Line"), value: 0 },
        { text: this.$t("International-Line"), value: 1 },
      ];
    },

    // Ekranda yalnizca secili hattin satirlari gosterilir; iki hat bir arada
    // 30'a yakin satir ediyor ve okunmuyordu. Kaydetme yine TUM listeyi
    // gonderir, yani gorunmeyen hattaki duzenlemeler korunur.
    /** Secili kume alis mi (alis iadesi DEGIL). */
    logoAlisMi() {
      return this.logoTur === "A";
    },

    /** Secili kume satis mi (satis iadesi DEGIL). */
    logoSatisMi() {
      return this.logoTur === "S";
    },

    /** Secili kumenin belge turu: 0 satis, 1 alis, 2 satis iadesi, 3 alis iadesi. */
    logoBelgeTuru() {
      return muhasebekodturu.KodTuruBelgeTuru(this.logoTur);
    },

    /** Secili kume iade kumelerinden biri mi (Kart kodu kolonu). */
    logoIadeMi() {
      return muhasebekodturu.IadeTuruMu(this.logoBelgeTuru);
    },

    /** GL_CODE1 kolonunun adi: alis ve alis iadesinde gider hesabi. */
    logoHesapEtiketi() {
      return this.logoBelgeTuru === 1 || this.logoBelgeTuru === 3
        ? "Gider hesabi"
        : "Gelir hesabi";
    },

    // Basliklar kumeye gore degisir. Alista KDV HESABI VAR: ic hat
    // alislarinda bilet ve vergi satirinin KDV'si ayrilip bu hesaba
    // (GL_CODE2) yaziliyor. Alista gosterilmeyenler: KDV durumu (alis
    // kombinasyonu KDV'ye gore ayrilmiyor) ve istisna kodu. IADE kumelerinde
    // KDV durumu ve istisna yok, Kart kodu (MASTER_CODE) var. Sablondaki
    // hucreler ayni kosula bagli; sayilari basliklarla tutmali.
    //
    // Yalnizca logoBelgeTuru'na bakar (testler bu computed'i tek alanli
    // sahte bir "this" ile cagiriyor).
    logoKodBasliklari() {
      const tur = this.logoBelgeTuru;
      const satis = tur === 0;
      const iade = muhasebekodturu.IadeTuruMu(tur);
      const b = [{ text: "Kalem", value: "SatirTipi", sortable: false }];

      if (satis) b.push({ text: "KDV", value: "KdvliMi", sortable: false });

      b.push({
        text: tur === 1 || tur === 3 ? "Gider hesabi" : "Gelir hesabi",
        value: "GelirKodu",
        sortable: false,
      });

      if (iade)
        b.push({ text: "Kart kodu (MASTER_CODE)", value: "MasterKodu", sortable: false });

      b.push({ text: "KDV hesabi", value: "KdvKodu", sortable: false });

      if (satis)
        b.push({ text: "Istisna kodu", value: "MuafiyetKodu", sortable: false });

      return b;
    },

    // Tur satirin BelgeTuru'ndan; onu tasimayan eski kayit AlisMi'den
    // turetilir (AlisMi de yoksa satis). Kural muhasebekodturu.js'te,
    // dismuhasebeaktarim.vue ile ORTAK.
    logoKodlarFiltreli() {
      return this.logoKodlar.filter(
        (k) =>
          (k.IcDis || "").trim().toUpperCase() === this.logoHat &&
          muhasebekodturu.SatirBelgeTuru(k) === this.logoBelgeTuru
      );
    },
  },

  methods: {
    // Sablon bu dort adi kullaniyor: ikisi tarihi ekranda gostermek, ikisi
    // alandan okumak icin. Iki tarih alani arasinda hicbir davranis farki
    // yok, bu yuzden ortak govdeye baglandilar; eskiden dordu de ayri ayri
    // kopyalanmisti ve ayni hatalari iki nusha halinde tasiyorlardi.
    formatDate: TarihBicimle,
    formatDate2: TarihBicimle,
    parseDate: TarihAyristir,
    parseDate2: TarihAyristir,

    getList: getList,
    CoperFatura: CoperFatura,
    LogoFatura: LogoFatura,
    LogoAlisFatura: LogoAlisFatura,
    LogoKodlariAc: LogoKodlariAc,
    LogoKodlariKaydet: LogoKodlariKaydet,
    DisMuhasebeAktarimiAc: DisMuhasebeAktarimiAc,
    LogoSatirTipiAdi: LogoSatirTipiAdi,
    HataYonetimi: HataYonetimi,
    HataMesajiCoz: HataMesajiCoz,

    TarihCoz: TarihCoz,
    getDateNow: getDateNow,
    beforeMountCalistir: beforeMount,
    AyinSonGunu: AyinSonGunu,
    onChange: onChange,
    onChange2: onChange2,
    filtrele: filtrele,
  },
};

function filtrele() {
  this.dialog = false;
  this.getList();
}

/**
 * Sunucu hatasindan kullaniciya gosterilecek mesaji cikarir.
 *
 * Asil uygulama artik `coper/tools.js` icinde: ayni davranis API'ye istek
 * atan TUM ekranlarda kullanilabilsin diye oraya tasindi. Burada yalnizca
 * $t'yi baglayan ince bir sarmalayici kaldi (mevcut testler bu metodu
 * `bilesen.methods.HataMesajiCoz` uzerinden cagiriyor).
 */
function HataMesajiCoz(response) {
  return tool.HataMesajiCoz(
    response,
    this && typeof this.$t === "function" ? this.$t.bind(this) : null
  );
}

function HataYonetimi(response, request, baslik) {
  this.load1 = true;
  if (response.status === 500) {
    this.$refs.hatadialog.open(response, request, baslik);
  } else {
    this.text1 = baslik + ": " + this.HataMesajiCoz(response);
    this.snackbar = true;
  }
}

function CoperFatura() {
  let params = {
    FatTip: 0, //None = 0, Satis = 1, Komisyon = 2, Iade = 3, Gelen = 4, SatisIadesi = 5
    CariKod: null,
    MuhEnt: null,
    SeriNo: null,
    FaturaNo: null,
    Tarih1: this.date,
    Tarih2: this.date2,
    PNR_No: null,
    IslemRef: null,
    SaticiTip: null,
    SaticiKod: null,
    GenelFatId: null,
  };

  return tool.api_post_FileDownload(this, "Coper/SatisFaturaEnt", params).then(
    (response) => {
      tool.CreateDownloadLink(response, "CoperFatura.xml");
      this.load1 = true;
    },
    (response) => {
      this.HataYonetimi(response, params, "CoperFatura Getirilemedi");
    }
  );
}

// Logo aktarim dosyasi. Delphi'deki ArkmanNextLogoFatura uygulamasinin
// yerini alir; ayrinti icin arkmanwebcore PORT-DURUMU.md.
function LogoFatura() {
  // Sirket ve veritabani bilgisi istekte tasinmaz; sunucu bunlari giris yapan
  // kullanicinin oturumundan (CariSirketNo basligi ve AED kaydi) cozer.
  let params = {
    BaslangicTarihi: this.date,
    BitisTarihi: this.date2,
    Hat: this.logoFiltreHat,
    // Sunucu bos/bosluk degeri "filtre yok" sayiyor (IsNullOrWhiteSpace);
    // yine de eski davranisla birebir kalmak icin null gonderiliyor.
    HavayoluKodu: (this.logoFiltreHavayolu || "").trim() || null,
    MusteriKodu: (this.logoFiltreMusteri || "").trim() || null,
    FaturaSeri: (this.logoFiltreFaturaSeri || "").trim() || null,
    FaturaNo: (this.logoFiltreFaturaNo || "").trim() || null,
  };

  return tool.api_post_FileDownload(this, "LogoEntegrasyon/LogoFaturaIndir", params).then(
    (response) => {
      tool.CreateDownloadLink(response, "LogoFatura.zip");
      this.load1 = true;
    },
    (response) => {
      this.HataYonetimi(response, params, "Logo Fatura Getirilemedi");
    }
  );
}

// Logo ALIS (bilet maliyeti) aktarimi.
//
// Satis ucundan ayri bir uctur ve filtreleri de farklidir: tarih araligi
// biletin SATIS tarihine uygulanir, fatura seri/no gonderilmez (alis
// faturasi biletten turer), buna karsilik BSP ve TL secenekleri vardir.
function LogoAlisFatura() {
  let params = {
    BaslangicTarihi: this.date,
    BitisTarihi: this.date2,
    Hat: this.logoFiltreHat,
    HavayoluKodu: (this.logoFiltreHavayolu || "").trim() || null,
    BspHaric: this.logoAlisBspHaric,
    TlAktar: this.logoAlisTlAktar,
    // Delphi ciktisindaki belge numarasi B_No_Kodu + BiletNo bicimindeydi.
    BelgeNoBiletNoKodundan: true,
  };

  return tool
    .api_post_FileDownload(this, "LogoEntegrasyon/LogoAlisFaturaIndir", params)
    .then(
      (response) => {
        tool.CreateDownloadLink(response, "LogoAlisFatura.zip");
        this.load1 = true;
      },
      (response) => {
        this.HataYonetimi(response, params, "Logo Alis Faturasi Getirilemedi");
      }
    );
}

// Secerek aktarim (dis muhasebe) sayfasina gecis. window.open("_self")
// kullanilir - bu dosyada hash navigasyonu icin zaten kurulu kalip
// (bkz. mounted()'taki yetkisiz yonlendirme); $router burada hic
// kullanilmiyor. Adres secili tipe gore (bkz. disMuhasebeAktarimAdresi).
function DisMuhasebeAktarimiAc() {
  window.open(this.disMuhasebeAktarimAdresi, "_self");
}

// Logo muhasebe kod eslesmeleri. Tablo bos oldugunda aktarim hicbir satira
// kod atayamiyor ve dosya uretilmiyor; bu dialog kullanicinin kodlari
// dogrudan girmesini saglar.
//
// Istek { IadeDahil: true }: sunucu iade satirlarini listeye YALNIZCA bunu
// isteyen istemciye ekliyor. Eski paketler (acik kalmis sekme, onbellekteki
// index.html) satirlari yalnizca AlisMi ile ayiriyor; iade satirlarini
// alsalardi Satis/Alis kumesinde ayni adla ikinci kez gosterir, oraya yazilan
// kodu da iade tablosuna gonderirlerdi. Eski sunucu govdeyi yok sayar.
function LogoKodlariAc() {
  this.logoKodDialog = true;
  this.logoKodYukleniyor = true;
  this.logoKodlar = [];

  tool.api_post(this, "LogoEntegrasyon/MuhasebeKodListesi", { IadeDahil: true }).then(
    (response) => {
      const kodlar = response.body || [];
      // Iade satirinda null MasterKodu JSON'da YOK (NullValueHandling.
      // Ignore); bos metinle tamamlanir, alan bos kutu olarak gorunsun.
      kodlar.forEach((k) => {
        if (
          k &&
          muhasebekodturu.IadeTuruMu(muhasebekodturu.SatirBelgeTuru(k)) &&
          (k.MasterKodu === null || k.MasterKodu === undefined)
        )
          k.MasterKodu = "";
      });
      this.logoKodlar = kodlar;
      this.logoKodYukleniyor = false;
    },
    (response) => {
      this.logoKodYukleniyor = false;
      this.HataYonetimi(response, {}, "Muhasebe kodlari getirilemedi");
    }
  );
}

// TUM liste gonderilir ve HER satira BelgeTuru yazilir (satirin kendi
// degeri, yoksa AlisMi'den turetilen): sunucu satiri bununla satis/alis ya
// da iade tablosuna yonlendiriyor. Ekrandaki satirlar degistirilmez, istek
// kopyalardan kurulur.
function LogoKodlariKaydet() {
  this.logoKodYukleniyor = true;

  const istek = this.logoKodlar.map((k) =>
    Object.assign({}, k, { BelgeTuru: muhasebekodturu.SatirBelgeTuru(k) })
  );

  // Promise DONDURULUR: kaydetbutonu bileseni cevabi bekleyip butonu
  // pasif tutmak icin buna ihtiyac duyuyor.
  return tool.api_post(this, "LogoEntegrasyon/MuhasebeKodKaydet", istek).then(
    () => {
      this.logoKodYukleniyor = false;
      this.logoKodDialog = false;
      this.text1 = "Muhasebe kodlari kaydedildi.";
      this.snackbar = true;
    },
    (response) => {
      this.logoKodYukleniyor = false;
      this.HataYonetimi(response, istek, "Muhasebe kodlari kaydedilemedi");
    }
  );
}

// MuhasebeEntegrasyon.Core.Model.SatirTipi ile ayni sirada.
// 1 "Vergi / harç": dismuhasebeaktarim.vue (KodSatirTipiAdi) ve sunucunun
// SatirTipiAdi ile AYNI ad; iki ekranda ayni kombinasyon farkli adla
// gorunmesin.
function LogoSatirTipiAdi(tip) {
  const adlar = [
    "Bilet bedeli",
    "Vergi / harç",
    "Servis ucreti",
    "Diger servis",
    "Iskonto",
    "Ek saha",
    "KDV masraf",
    "Ozel islem",
    "Ceza",
    "Alan vergisi",
  ];
  return adlar[tip] !== undefined ? adlar[tip] : "Tip " + tip;
}

function getList() {
  // Onceki islemden kalan mesaj yeni islemin sonucu saniliyordu; temizleniyor.
  this.text1 = "";

  // Promise DONDURULUR: kaydetbutonu bileseni istek bitene kadar
  // butonu pasif tutmak icin buna ihtiyac duyuyor.
  return this.$validator.validateAll().then((result) => {
    if (result) {
      var bastarih = new Date(this.date);
      var bittarih = new Date(this.date2);

      if (bastarih <= bittarih) {
      const diffTime = Math.abs(bittarih - bastarih);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
      
      if(diffDays > 30){
        this.text1 = this.$t('You-can-receive-your-Integration-File-once-30-days-maximum')
        this.snackbar = true;
        return false;
      }
        var credentials = JSON.parse(
          window.localStorage.getItem("credentials")
        );

        this.load1 = false;

        var params = {
          SirketKodu: credentials.SirketKodu,
          BaslangicTarih: this.date,
          BitisTarih: this.date2,
          GeciciStatus: this.geciciStatus,
        };

        if (this.tip == "0") {
          return this.$http
            .post(
              auth.API_URL + "api/TicketIntegration/DownloadTicketIntegration",
              params,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                tool.CreateDownloadLink(response, "bilet_entegrasyon.xml");
                this.load1 = true;
              },
              (response) => {
                this.text1 = this.HataMesajiCoz(response);
                this.snackbar = true;
                this.load1 = true;
              }
            );
        } else if (this.tip == "1") {
          return this.$http
            .post(
              auth.API_URL + "api/TicketIntegration/DownloadInvoiceIntegration",
              params,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                tool.CreateDownloadLink(response, "fatura_entegrasyon.xml");
                this.load1 = true;
              },
              (response) => {
                this.text1 = this.HataMesajiCoz(response);
                this.snackbar = true;
                this.load1 = true;
              }
            );
        } else if (this.tip == "2") {
          var params1 = {
            SirketKodu: credentials.SirketKodu,
            BaslangicTarihi: this.date,
            BitisTarihi: this.date2,
          };

          return this.$http
            .post(
              auth.API_URL + "api/TicketIntegration/DownloadRefundIntegration",
              params1,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                tool.CreateDownloadLink(response, "iade_entegrasyon.xml");
                this.load1 = true;
              },
              (response) => {
                this.text1 = this.HataMesajiCoz(response);
                this.snackbar = true;
                this.load1 = true;
              }
            );
        } else if (this.tip == "3") {
          var params2 = {
            SirketKodu: credentials.SirketKodu,
            BaslangicTarihi: this.date,
            BitisTarihi: this.date2,
            Entegre: true,
            ListTipi: 3,
          };

          return this.$http
            .post(
              auth.API_URL +
                "api/TicketIntegration/DownloadCurrentMovementIntegration",
              params2,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                tool.CreateDownloadLink(response, "cari_entegrasyon.xml");
                this.load1 = true;
              },
              (response) => {
                this.text1 = this.HataMesajiCoz(response);
                this.snackbar = true;
                this.load1 = true;
              }
            );
        } else if (this.tip == "4") {
          var params3 = {
            SirketKodu: credentials.SirketKodu,
            BaslangicTarih: this.date,
            BitisTarih: this.date2,
          };

          return this.$http
            .post(
              auth.API_URL +
                "api/TicketIntegration/DownloadFreeInvoiceIntegration",
              params3,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                tool.CreateDownloadLink(response, "serbestfatura_entegrasyon.xml");
                this.load1 = true;
              },
              (response) => {
                this.text1 = this.HataMesajiCoz(response);
                this.snackbar = true;
                this.load1 = true;
              }
            );
        } else if (this.tip == "5") {
          return this.CoperFatura();
        } else if (this.tip == "6") {
          return this.LogoFatura();
        } else if (this.tip == "7") {
          return this.LogoAlisFatura();
        }
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true;
      }
    } else {
      // Dogrulama basarisiz. vee-validate alanlarin altina zaten uyari
      // basiyor, ama kullanici indirme butonuna bastigi icin geri bildirimi
      // orada bekliyor; else dali olmadigi surece buton bir sey olmamis gibi
      // gorunuyordu.
      this.text1 = this.$t('Please-fill-required-fields');
      this.snackbar = true;
    }
  });
}

function beforeMount() {
  // Bugun TEK KEZ hesaplanir. Onceden dort ayri new Date() cagrisi vardi;
  // gece yarisini geciren bir anda iki tarih alani farkli gunlere
  // dusebiliyordu.
  const bugun = getDateNow();

  this.date = bugun;
  this.date2 = bugun;
  this.dateFormatted = TarihBicimle(bugun);
  this.dateFormatted2 = TarihBicimle(bugun);
}

function onChange(v) {
  TarihAlaniniGuncelle(this, v, "date", "dateFormatted");
}

function onChange2(v) {
  TarihAlaniniGuncelle(this, v, "date2", "dateFormatted2");
}

/**
 * Elle yazilan tarihi cozup ilgili alanlara yazar.
 *
 * onChange ve onChange2 birebir ayni 47 satiri tasiyordu; tek fark hangi
 * alana yazdiklariydi. Ayni hata iki nusha halinde duruyordu, bu yuzden
 * ortak hale getirildi.
 */
function TarihAlaniniGuncelle(vm, giris, isoAlan, gosterimAlan) {
  const t = TarihCoz(giris);

  if (!t) {
    vm[gosterimAlan] = null;
    return;
  }

  vm[isoAlan] = t.iso;
  vm[gosterimAlan] = t.gosterilen;
}

/**
 * Alandan cikilirken (@blur) okunan tarihi ISO bicimine cevirir.
 *
 * Alan maskeli oldugu icin deger genelde "ggAAyyyy" (8 hane) gelir, ama
 * noktali "gg.AA.yyyy" de gelebilir; ayraclar atilip ikisi de kabul edilir.
 *
 * Cozulemezse null doner.
 *
 * ONCEKI HALI: hicbir girdide deger DONDURMUYORDU - yani @blur her
 * seferinde date'i undefined yapiyordu - ve bir dalda kullanicinin girdigi
 * tarihi sessizce BUGUNE cekiyordu. Uygulamanin calisiyor gorunmesi,
 * onChange'in ayni alani ayrica dogru yazmasi sayesindeydi.
 */
function TarihAyristir(deger) {
  if (!deger) return null;

  const t = TarihCoz(String(deger).replace(/\D/g, ""));
  return t ? t.iso : null;
}

/**
 * ISO tarihi ekranda gosterilen "gg.AA.yyyy" bicimine cevirir.
 *
 * ONCEKI HALI: str.search(".") ile bir on kontrol yapiyordu, ama search
 * REGEX bekliyor ve "." "herhangi bir karakter" demek; deger ne olursa
 * olsun 0 donuyordu, yani o dal hicbir zaman calismiyordu.
 */
function TarihBicimle(iso) {
  if (!iso) return null;

  const [yil, ay, gun] = String(iso).split("-");
  if (!yil || !ay || !gun) return null;

  return gun + "." + ay + "." + yil;
}

/**
 * "ggAAyyyy" biciminde yazilan tarihi cozer.
 *
 * Ay sonunu asan gun DUZELTILIR (31 Nisan -> 30 Nisan, artik olmayan yilda
 * 29 Subat -> 28 Subat). Bu elle kontrol gerekli: JavaScript gecersiz gunu
 * reddetmiyor, sessizce TASIRIYOR - new Date("2026-04-31") 1 Mayis,
 * new Date("2026-02-29") 1 Mart donuyor. Yani isNaN kontrolune guvenilemez.
 *
 * Cozulemeyen girdide null doner; cagiran gosterim alanini temizler.
 */
function TarihCoz(giris) {
  if (!giris || giris.length !== 8) return null;

  const gun = parseInt(giris.slice(0, 2), 10);
  const ay = parseInt(giris.slice(2, 4), 10);
  const yil = parseInt(giris.slice(4, 8), 10);

  if (!gun || !ay || !yil || ay < 1 || ay > 12 || gun < 1) return null;

  const duzeltilmis = Math.min(gun, AyinSonGunu(ay, yil));
  const ik = (n) => String(n).padStart(2, "0");

  return {
    iso: yil + "-" + ik(ay) + "-" + ik(duzeltilmis),
    gosterilen: ik(duzeltilmis) + "." + ik(ay) + "." + yil,
  };
}

/**
 * Ayin son gunu. Artik yil kurali: 4'e bolunur; 100'e bolunuyorsa 400'e de
 * bolunmeli.
 *
 * Onceki kod bunu "yil % 10" diye yaziyordu ve kural neredeyse tersine
 * calisiyordu: gecerli 29 Subat'lar (2028, 2032) sessizce 28'e cekiliyor,
 * gecersiz olanlar (2030) oldugu gibi geciyordu.
 */
function AyinSonGunu(ay, yil) {
  const artik = yil % 4 === 0 && (yil % 100 !== 0 || yil % 400 === 0);
  return [31, artik ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][ay - 1];
}

/**
 * Bugunun ISO bicimi (yyyy-AA-gg).
 *
 * Sayfa her tarihi IKI bicimde tutuyor: ISO olan API'ye ve v-date-picker'a
 * gidiyor, noktali olan metin alaninda gorunuyor. Bu yuzden eskiden iki ayri
 * "bugun" fonksiyonu vardi (getDateNow / getDateNow1); ikincisi kaldirildi,
 * gosterim bicimi artik TarihBicimle ile uretiliyor.
 */
function getDateNow() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }
  today = yyyy + "-" + mm + "-" + dd;
  return today;
}

</script>

<style>
</style>
